export default {
    title: "Poznámky",
    text_0: "Historie úprav",
    text_1: "Úprava poznámky",
    text_2: "Tvorba poznámky",
    text_3: "Datum",
    text_4: "Poznámka",
    text_5: "Uložit",
    text_6: "Ukončit",
    text_7: "Aktuálně nemáš žádné poznámky.",
    text_alert_1: "Poznámka byla odstraněna.",
    text_alert_2: "Poznámka byla vytvořena",
    text_alert_3: "Poznámka byla upravena",
};
